const BASE = "/api";

export async function api(path, opts = {}) {
  const token = localStorage.getItem("token");
  const csrfToken = localStorage.getItem("csrf_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (csrfToken && opts.method && opts.method !== "GET") headers["X-CSRF-Token"] = csrfToken;
  const isForm = opts.formData;
  try {
    const res = await fetch(BASE + path, {
      ...opts,
      headers: isForm
        ? { Authorization: `Bearer ${token}`, "X-CSRF-Token": csrfToken }
        : { ...headers, ...(opts.headers || {}) },
      body: isForm
        ? opts.formData
        : opts.body
          ? JSON.stringify(opts.body)
          : undefined,
    });
    if (res.status === 401 && !path.includes("/auth/me")) {
      localStorage.removeItem("token");
      window.location.href = "/";
      return;
    }
    if (!res.ok) {
      const raw = await res.text();
      let detail = raw || `خطأ ${res.status}`;
      try {
        const d = JSON.parse(raw);
        detail = d.detail || d.message || detail;
      } catch {
        // raw body wasn't JSON (e.g. HTML error page from a proxy) — keep raw text
      }
      throw new Error(detail);
    }
    const text = await res.text();
    return text ? JSON.parse(text) : null;
  } catch (error) {
    if (error.name === "TypeError" && error.message.includes("fetch")) {
      throw new Error("خطأ في الاتصال بالخادم - تأكد من تشغيل النظام");
    }
    throw error;
  }
}
